import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import ProgressDots from "../components/ProgressDots";
import ProductImage from "../components/ProductImage";
import PrimaryButton from "../components/PrimaryButton";
import { t, tNode } from "../services/i18n";

export default function GettingStartedPage() {
  const navigate = useNavigate();
  const steps = tNode<string[]>("gettingStarted.steps", []);
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <AppHeader title={t("gettingStarted.title")} backTo="/" />
      <div className="page">
        <ProgressDots total={4} current={0} />
        <h2 className="h1">{t("gettingStarted.heading")}</h2>
        <ol className="step-list mt-24">
          {steps.map((s, i) => (
            <li className="step-item" key={i}>
              <span className="step-item__num" aria-hidden="true">{i + 1}</span>
              {s}
            </li>
          ))}
        </ol>
        <ProductImage small />
        <div className="mt-auto">
          <PrimaryButton label={t("common.continue")} onClick={() => navigate("/hand-position")} />
        </div>
      </div>
    </>
  );
}
